import classNames from 'classnames';
import { useLayoutEffect, useState } from 'react';
import { ProductPricesCollection } from 'palette/candidates/ProductPrices/types';
import { useProductCardContext } from 'palette/ProductCard';
import { IColors, IPrices, Thumbnail } from 'palette/ProductCard/types/productData';
import { Transition } from 'palette/Transition';
import SizeList from '../SizeList';
import Thumbnails from '../Thumbnails';
import Prices from './Prices';
import PriceWrapper from './PriceWrapper';

import './Hover.scss';

interface HoverProps {
    thumbnails: Thumbnail[];
    prices: IPrices;
    pricesStructure: ProductPricesCollection[];
    colors: IColors;
}

function Hover({
    thumbnails,
    prices,
    pricesStructure,
    colors,
}: HoverProps) {
    const [isVisible, setIsVisible] = useState(false);
    const {
        size: cardSize,
        showSizesOnHover,
        imageBackground,
        activeVariantId,
    } = useProductCardContext();

    useLayoutEffect(() => {
        setTimeout(() => {
            setIsVisible(true);
        }, 10); // need timeout because otherwise animation is sometimes omitted
    }, []);

    return (
        <Transition
            appear
            property="opacity"
            timeout="slow"
        >
            <div className={classNames('palette-product-card-hover', {
                [`palette-product-card-hover--${imageBackground}-background`]: imageBackground,
                'palette-product-card-hover--visible': isVisible,
            })}
            >
                <Thumbnails
                    colors={colors}
                    thumbs={thumbnails}
                />
                <div className="palette-product-card-hover__content">
                    {
                        thumbnails.map(({ variantId, sizes }) => (
                            <div
                                key={variantId}
                                className={classNames('palette-product-card-hover__variant', {
                                    'palette-product-card-hover__variant--visible': Number(activeVariantId) === variantId,
                                })}
                            >
                                {
                                    pricesStructure && (
                                        <PriceWrapper
                                            bemModifier={cardSize}
                                            pricesStructure={pricesStructure}
                                        />
                                    )
                                }
                                {
                                    !pricesStructure && (
                                        <Prices
                                            bemModifier={cardSize}
                                            prices={prices[variantId]}
                                        />
                                    )
                                }
                                {
                                    showSizesOnHover && (
                                        <SizeList
                                            className="palette-product-card-hover__size-list"
                                            sizes={sizes}
                                        />
                                    )
                                }
                            </div>
                        ))
                    }
                </div>
            </div>
        </Transition>
    );
}

export default Hover;
